var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { filterable: "", clearable: "", placeholder: "状态" },
              model: {
                value: _vm.searchData.status,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "status", $$v)
                },
                expression: "searchData.status"
              }
            },
            _vm._l(_vm.statusList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "350px" },
            attrs: {
              clearable: "",
              "end-placeholder": "结束日期",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              type: "daterange",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd"
            },
            model: {
              value: _vm.searchData.time,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "time", $$v)
              },
              expression: "searchData.time"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchAnnouncementList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "升级服务区域" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.announceRegions(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "升级App" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.announceApps(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumn, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "上架状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.announceStatus(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.offShelfItem(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.status == 1 ? "下架" : "上架"))]
                    ),
                    _vm._v(" "),
                    scope.row.status == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.editItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            width: "700px",
            title: _vm.announceForm.id ? "编辑公告通知" : "新增公告通知",
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            open: _vm.onAddDialogOpen,
            close: _vm.onAddDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "announceForm",
              attrs: {
                rules: _vm.announceFormRule,
                "validate-on-rule-change": false,
                "label-width": "120",
                model: _vm.announceForm
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "选择服务区域",
                    prop: "servicesRegionalList",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择升级区域(可多选)"
                      },
                      model: {
                        value: _vm.announceForm.servicesRegionalList,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.announceForm,
                            "servicesRegionalList",
                            $$v
                          )
                        },
                        expression: "announceForm.servicesRegionalList"
                      }
                    },
                    _vm._l(_vm.regionList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.regionalName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "弹窗文案内容",
                    prop: "notifyContent",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请填写弹窗内容(200字以内)",
                      maxlength: "200",
                      type: "textarea",
                      rows: "5"
                    },
                    model: {
                      value: _vm.announceForm.notifyContent,
                      callback: function($$v) {
                        _vm.$set(_vm.announceForm, "notifyContent", $$v)
                      },
                      expression: "announceForm.notifyContent"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "弹窗开始时间",
                    prop: "startTime",
                    required: ""
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      editable: false,
                      "picker-options": _vm.pickerOptions,
                      type: "date",
                      clearable: "",
                      placeholder: "请选择时间",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd"
                    },
                    on: {
                      focus: _vm.onDatePickerFocus,
                      change: _vm.onStartTimeChange
                    },
                    model: {
                      value: _vm.announceForm.startTime,
                      callback: function($$v) {
                        _vm.$set(_vm.announceForm, "startTime", $$v)
                      },
                      expression: "announceForm.startTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "弹窗结束时间",
                    prop: "endTime",
                    required: ""
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.announceForm.id ? true : false,
                      editable: false,
                      "picker-options": _vm.pickerOptions,
                      type: "date",
                      clearable: "",
                      placeholder: "请选择时间",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd"
                    },
                    on: {
                      focus: _vm.onDatePickerFocus,
                      change: _vm.onEndTimeChange
                    },
                    model: {
                      value: _vm.announceForm.endTime,
                      callback: function($$v) {
                        _vm.$set(_vm.announceForm, "endTime", $$v)
                      },
                      expression: "announceForm.endTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "App是否全部",
                    prop: "appUpType",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.announceForm.appUpType,
                        callback: function($$v) {
                          _vm.$set(_vm.announceForm, "appUpType", $$v)
                        },
                        expression: "announceForm.appUpType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("否")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.announceForm.appUpType) == 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "选择弹窗App",
                        prop: "appInfoList",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: "请选择弹窗App(可多选)"
                          },
                          model: {
                            value: _vm.announceForm.appInfoList,
                            callback: function($$v) {
                              _vm.$set(_vm.announceForm, "appInfoList", $$v)
                            },
                            expression: "announceForm.appInfoList"
                          }
                        },
                        _vm._l(_vm.appList, function(item, index) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveAnnounce }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }